import React from "react";
import {Col} from "antd";
import {CourierFilter, SearchText} from "../../../../_defaultComponents/FilterComponents";

export const CourierTerminalHistoryTabFilters = ({filters, setFilters}) => {
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CourierFilter
                    value={filters.courierId}
                    onChange={value => setFilters({...filters, courierId: value})}
                    allowClear={true}
                />
            </Col>
        </React.Fragment>
    );
};
